module.exports = __webpack_public_path__ + "static/media/truck_3t_light.66d95cd2.svg";